import React from 'react';

export default function EmptyState({ icon = 'bi-inbox', title = 'No records found', message, action }) {
  return (
    <div className="empty-state">
      <i className={`bi ${icon}`}></i>
      <h5>{title}</h5>
      {message && <p className="text-muted" style={{ fontSize: 13 }}>{message}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
